// Canonical share/join URLs for a meet room — registered (el.call) so every
// builder (ControlBar share, RoomSettingsModal copy, calendar booking links)
// emits ONE shape.
//
// The workspace link MUST carry the `/w/<org-slug>` prefix of the room's
// OWNING org. A bare `${origin}/meet#room=…` link resolves on the RECIPIENT's
// side to whatever org their boot pins (their last-active org) — which is how
// a system-org call invite landed a user inside /w/natali with the room's
// workspace-scoped surfaces (record, participants, transcripts) reading the
// wrong tenant (2026-07-29, critical). The sharer's ACTIVE org is the room's
// org — the rooms list is workspace-scoped, a sharer can only share rooms of
// the org they're in.
//
// Guest links stay unprefixed — /meet-guest is a public surface with no org
// boot; the guest flow resolves the room server-side.
import { withWorkspacePath } from '@symbo-ls/workspace-shared/functions/workspacePrefix.js'
import { resolveWorkspaceUrlHandle } from '@symbo-ls/workspace-shared/functions/workspaceUrlSync.js'

export const meetRoomUrl = function (root, roomId, opts) {
  if (!roomId || typeof window === 'undefined') return ''
  const origin = window.location.origin
  if (opts && opts.guest) return `${origin}/meet-guest#room=${roomId}`
  const org = root && root.org
  const slug = (org && (org.slug || org.username)) || null
  // Scheme A: carry the WORKSPACE segment too (shared rule — non-HQ always).
  // Rooms are workspace-scoped, so an org-only link resolved on the
  // recipient's side to THEIR pointer/HQ workspace of that org — same class
  // of bug as the org mismatch above, one level down.
  const handle = resolveWorkspaceUrlHandle({
    workspace: root && root.workspace,
    org,
    workspaces: root && Array.isArray(root.workspaces) ? root.workspaces : []
  })
  return `${origin}${withWorkspacePath(slug, handle, '/meet')}#room=${roomId}&view=call`
}
